import { useTranslation } from "react-i18next";
import { FinancialApi as FinancialApiProd } from "../services/akfenservicesprod/api";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import RasyonetLine from "../assets/images/rasyonet-line.png";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { Dialog } from "primereact/dialog";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "chartjs-adapter-date-fns";

function Financial() {
  //#region API
const financialProdApi = new FinancialApiProd({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = financialProdApi;

  //#endregion

  //#region useState
  const chartRef = useRef();
  const [visible, setVisible] = useState(false);
  const [selectedLang, setSelectedLang] = useState("");
  const [onlyYear, setOnlyYear] = useState(true);
  const [showTtm, setShowTtm] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [currencies, setCurrencies] = useState();
  const [quarter, setQuarter] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState();
  const [headerData, setHeaderData] = useState();
  const [pageData, setPageData] = useState([]);
  const [modalName, setModalName] = useState("");
  const [modalLabel, setModalLabel] = useState([]);
  const [modalData, setModalData] = useState([]);

  const chartOptions = {
    responsive: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const number = parseFloat(tooltipItem.raw);
            return number.toLocaleString();
          },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: "black",
          font: {
            size: 12,
            weight: "bold",
          },
          callback: function (label) {
            return label.toLocaleString();
          },
        },
      },
      x: {
        ticks: {
          color: "black",
          font: {
            size: 12,
            weight: "bold",
          }          
        },
      },
    },
  };
  
  const data = {
    labels: modalLabel,
    datasets: [
      {
        data: modalData,
        borderColor: "#193954",
        backgroundColor: "#193954",
        borderWidth: 0,
        fill: false,
      },
    ],
  };
  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  //#endregion

  //#region Page Load Data
  const financialData = () => {
    if (api !== undefined && api !== "") {
      api
        .financialReturnGet(
          // TTM görünümleri Mongo'da TRLTTM/USDTTM/EURTTM para kodlarıyla saklanır.
          selectedCurrency["name"] + (showTtm ? "TTM" : ""),
          selectedLang === "tr-TR" ? 1 : 2,
          onlyYear,
          selectedQuarter,
          "sec.101.84224"
        )

        .then((response) => {
          if (response.status === 200) {
            let datas = response.data;
            setHeaderData(datas["headers"]);
            setPageData(datas["values"]);
          }
        });
    }
  };

  const QuarterData = () => {
    if (api !== undefined && api !== "") {
      api.financialQuartersGet(selectedLang).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          // 2024/09 öncesi dönemlerde sadece yıl sonları (Aralık) gösterilir,
          // 2024/09 ve sonrasında tüm çeyrekler listelenir.
          var filtered = datas.filter(
            (q) => Number(q.value) >= 202409 || Number(q.value) % 100 === 12
          );
          var sortData = filtered.reverse().slice(0, 12);
          setQuarter(sortData);
          setSelectedQuarter(sortData[0].value);
        }
      });
    }
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (window.location.pathname.indexOf("financial") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
      setCurrencies([
        { name: "TRL", code: "Turkish Lira" },
        { name: "USD", code: "Dollar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    } else {
      setSelectedLang("tr-TR");
      setCurrencies([
        { name: "TRL", code: "Türk Lirası" },
        { name: "USD", code: "Dolar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    }
  }, []);

  useEffect(() => {
    if (selectedLang !== undefined && selectedLang !== "") QuarterData();
  }, [selectedLang]);

  useEffect(() => {
    if (selectedQuarter !== undefined && selectedCurrency !== undefined)
      financialData();
  }, [selectedQuarter, selectedCurrency, onlyYear, showTtm]);
  //#endregion

  //#region Page Helper

  // Tüm tutarlar ekranda gösterimsel olarak bu katsayıya bölünür.
  // Tablo başındaki "Katsayı: 1000" notu bu bölmeyi ifade eder.
  const COEFFICIENT = 1000;

  // Tutarlar küsuratsız (tam sayı) gösterilir; oran satırları bu fonksiyondan geçmez.
  const formatAmount = (num) =>
    num.toLocaleString(selectedLang === "tr-TR" ? "tr-TR" : "en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  // Bu metrikler oran/kur/tarih olduğu için 1000 katsayısından hariç tutulur:
  // açıklanma tarihi, döviz kuru, hisse başına kar, net borç/FAVÖK,
  // FAVÖK marjı ve öz kaynaklar/aktif toplamı. (TR ve EN etiketleri karşılanır.)
  const isExcludedFromDivision = (name) => {
    if (!name) return false;
    // Not: tr-TR kuralıyla küçültmede büyük "I" noktasız "ı" olur ("EBITDA" -> "ebıtda")
    // ve İngilizce etiketler eşleşmez. Bu yüzden hem standart hem tr-TR küçültme denenir.
    const raw = String(name);
    const variants = [raw.toLowerCase(), raw.toLocaleLowerCase("tr-TR")];
    return variants.some((n) => {
      const compact = n.replace(/\s+/g, "");
      return (
        n.includes("açıklanma tarihi") ||
        n.includes("announcement date") ||
        n.includes("disclosure date") ||
        n.includes("döviz kuru") ||
        n.includes("exchange rate") ||
        n.includes("hisse başına") ||
        n.includes("earnings per share") ||
        compact.includes("borç/favök") ||
        compact.includes("debt/ebitda") ||
        n.includes("favök marjı") ||
        // "EBITDA Margin" ve "EBITDA (Adjusted) Margin" gibi araya ek giren yazımlar da yakalanır.
        /ebitda.*margin|margin.*ebitda/.test(n) ||
        compact.includes("kaynaklar/aktif") ||
        compact.includes("equity/totalassets")
      );
    });
  };

  const openModal = (item) => {

    setModalName(item.c1);
    setVisible(true);

    const divide = !isExcludedFromDivision(item.c1);

    var modalL = [item.cQ2, item.cQ3, item.cQ4, item.cQ5, item.cQ6];
    // Grafik değerleri de tablodaki gibi 1000'e bölünüp küsuratsız gösterilir (hariç tutulanlar hariç).
    var modalD = [item.cV2, item.cV3, item.cV4, item.cV5, item.cV6].map((v) => {
      const num = parseFloat(v);
      if (isNaN(num)) return v;
      return divide ? Math.round(num / COEFFICIENT) : num;
    });

    setModalLabel(modalL);
    setModalData(modalD);
  };

  const returnItem = (item, index) => {
    if (
      (index > 0 && selectedCurrency["name"] === "TRL") ||
      (index > 1 && selectedCurrency["name"] !== "TRL")
    ) {
      return (
        <i
          className="fas fa-eye"
          onClick={() => {
            openModal(item);
          }}
        ></i>
      );
    } else {
      <i></i>;
    }
  };

  const formatedDate = (value, item) => {
    // Dönem bitiş tarihleri (ISO tarih hücreleri) tarih olarak gösterilir.
    if (
      value !== "" &&
      value !== undefined &&
      typeof value === "string" &&
      value.indexOf("T00") !== -1
    ) {
      const isoDate = value;
      const formatted = moment(isoDate).format("DD.MM.YYYY");
      return formatted;
    }

    // Oran/kur/tarih satırları katsayıdan hariç: değerleri olduğu gibi gösterilir.
    if (isExcludedFromDivision(item?.c1)) {
      return value;
    }

    // Sayısal tutarlar gösterimsel olarak 1000'e bölünür (Katsayı: 1000).
    if (value !== "" && value !== null && value !== undefined) {
      const num = parseFloat(String(value).replace(/,/g, ""));
      if (!isNaN(num) && String(value).trim() !== "") {
        return formatAmount(num / COEFFICIENT);
      }
    }

    return value;
  };

  //#endregion

  //#region Column Visibility
  // TTM görünümünde 2024/12 (202412) öncesi dönemler ekranda gösterilmez:
  // bu dönemlerde uyguladığımız enflasyon düzeltmesi katsayısı karşı taraftan
  // farklı olduğu için tutarlar uyuşmuyor ve kullanıcılar fark görüyor.
  const TTM_MIN_PERIOD = 202412;

  // Bir dönem etiketini/tarihini YYYYMM sayısına çevirir (ör. 202412).
  const periodFromValue = (raw) => {
    if (raw === null || raw === undefined || raw === "") return null;
    const s = String(raw).trim();
    let m = s.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})/); // dd.mm.yyyy
    if (m) return Number(m[3]) * 100 + Number(m[2]);
    m = s.match(/^(\d{4})-(\d{1,2})/); // ISO: yyyy-mm-dd
    if (m) return Number(m[1]) * 100 + Number(m[2]);
    m = s.match(/^(\d{4})[./](\d{1,2})/); // yyyy/mm veya yyyy.mm
    if (m) return Number(m[1]) * 100 + Number(m[2]);
    m = s.match(/^(\d{4})(\d{2})$/); // yyyymm
    if (m) return Number(m[1]) * 100 + Number(m[2]);
    return null;
  };

  // Dönem bitiş tarihlerini içeren satır (ISO tarih hücreleri) — header'dan
  // dönem çıkarılamazsa dönem bilgisini buradan alırız.
  const dateRow = pageData?.find(
    (row) => typeof row?.c2 === "string" && row.c2.indexOf("T00") !== -1
  );

  // Tarih kolonları (c2..c6) header etiketleri ve dönemleriyle birlikte.
  const dateColumns = (headerData || []).slice(1).map((header, i) => {
    const key = `c${i + 2}`;
    const period =
      periodFromValue(header) ??
      periodFromValue(dateRow ? dateRow[key] : null);
    return { key, header, period };
  });

  // TTM'de eski dönemleri ele; ardından en güncel tarih solda olacak şekilde çevir.
  const visibleColumns = dateColumns
    .filter(
      (col) => !(showTtm && col.period !== null && col.period < TTM_MIN_PERIOD)
    )
    .reverse();
  //#endregion

  return (
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-12 col-md-center">
      <div className="financial">
        <div className="pageHeader mb-4">
          <div className="title"> {t("KeyFinancialData")}</div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="selectArea d-flex align-items-center position-relative w-100">
              <Dropdown
                value={selectedCurrency}
                onChange={(e) => {
                  setSelectedCurrency(e.value);
                }}
                options={currencies}
                optionLabel="code"
                className=" customDropdown me-3"
                panelClassName="customDropdownPanel"
              />

              <Dropdown
                value={selectedQuarter}
                onChange={(e) => {
                  setSelectedQuarter(e.value);
                }}
                options={quarter}
                optionLabel="name"
                className=" customDropdown me-3"
                panelClassName="customDropdownPanel "
              />

              <Checkbox
                inputId="onlyYear"
                onChange={(e) => setOnlyYear(e.checked)}
                checked={onlyYear}
              />
              <label htmlFor="onlyYear" className="ms-2 checkLabel">
                {t("onlyYear")}
              </label>

              <Checkbox
                inputId="showTtm"
                className="ms-3"
                onChange={(e) => setShowTtm(e.checked)}
                checked={showTtm}
              />
              <label htmlFor="showTtm" className="ms-2 checkLabel">
                {t("showTtm")}
              </label>
            </div>

            <div
              className="coefficientNote text-end w-100 mt-3"
              style={{ fontWeight: "bold", fontSize: "0.85rem" }}
            >
              {t("coefficientNote")}
            </div>

            <div className="financialTable d-inline-block position-relative w-100 mt-1">
              <table className="w-100">
                <thead>
                  <tr>
                    {headerData && (
                      <>
                        {/* İlk kolon (metrik adı) solda sabit kalır */}
                        <th>{headerData[0]}</th>
                        {/* En güncel tarih solda; TTM'de 2024/12 öncesi gizli */}
                        {visibleColumns.map((col, i) => (
                          <th key={i}>{col.header}</th>
                        ))}
                      </>
                    )}
                    <th className="text-center"> {t("Graphic")}</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.c1}</td>
                      {/* En güncel tarih solda; TTM'de 2024/12 öncesi gizli */}
                      {visibleColumns.map((col) => (
                        <td key={col.key}>{formatedDate(item[col.key], item)}</td>
                      ))}
                      <td>{returnItem(item, index)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="note text-end d-inline-block w-100">
              {t("financialNote1")} <br /> {t("financialNote2")} <br />
             
            </div>

            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang !== "tr-TR" ? "d-none" : ""
              }`}
            >
              *** Piyasa verileri
              <Link to="https://www.rasyonet.com.tr/tr" target="_blank">
                <img src={RasyonetLine} />
              </Link>
              tarafından sağlanmaktadır.
            </div>
            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang === "tr-TR" ? "d-none" : ""
              }`}
            >
              *** The share information data is provided by{" "}
              <Link to="https://www.rasyonet.com.tr/en" target="_blank">
                <img src={RasyonetLine} />
              </Link>
            </div>
          </div>
        </div>
      </div>
      </div>
        </div>
      <Dialog
        header={modalName}
        visible={visible}
        style={{ width: "45vw" }}
        onHide={() => setVisible(false)}
        draggable={false}
        className="customModal"
      >
        <Bar
          className="mt-2 w-100"
          ref={chartRef}
          data={data}
          height={400}
          width={800}
          options={chartOptions}
        />
      </Dialog>
    </div>
  );
}

export default Financial;
